import React from "react";
import PropTypes from "prop-types";

import { Message } from "semantic-ui-react";

import { useIntegrationAction } from "../../hooks";
import { WealthboxForm } from "./components";

export function WealthboxSection({ onDone, disabled, children }) {
  const { connect, connecting, error } = useIntegrationAction(onDone);

  return (
    <React.Fragment>
      <Message data-test="error-container" negative hidden={!error}>
        <Message.Header>Error</Message.Header>
        <p>{error}</p>
      </Message>

      <WealthboxForm
        onSubmit={({ accessToken }) => {
          return connect("WEALTHBOX", accessToken);
        }}
        loading={connecting}
        disabled={disabled}
      />
      {children}
    </React.Fragment>
  );
}

WealthboxSection.propTypes = {
  onDone: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

WealthboxSection.defaultProps = {
  onDone: () => {},
  disabled: false,
  children: undefined,
};

export default WealthboxSection;
